import styled from 'styled-components';
import IMG_GUIDE_KOR_3_2 from '@/assets/korUploadFile/img_guide_3_2.png';
import IMG_CHECK_1 from '@/assets/korUploadFile/img_check_1.png';

const ExplainDetail = () => {
  return (
    <div>
      <Wrapepr>
        <TitleWrapper>
          <Number>1</Number>
          <SubTitle>
            기록대조일 입력 <Strong>예시</Strong>
          </SubTitle>
        </TitleWrapper>
        <div>
          <ExampleWrapper>
            <ExampleText>
              <Strong>[예시]</Strong> 2025년 4월 13일 출국
            </ExampleText>
            <TextWrapper>
              <Text $isRed>
                기록대조 시작일 : 출국일자 기준 3년전 날짜 입력
                <br />
                <Small>예) 기록대조 시작일: 2022년 04월 13일</Small>
              </Text>
              <Text $isRed>
                기록대조 종료일 : 출국일자 + 1일
                <br />
                <Small>예) 기록대조 종료일: 2025년 4월 14일</Small>
              </Text>
            </TextWrapper>
          </ExampleWrapper>
          <img
            src={IMG_CHECK_1}
            alt=''
            width='100%'
            style={{ marginTop: '16px' }}
          />
        </div>
      </Wrapepr>
      <SecondImg src={IMG_GUIDE_KOR_3_2} alt='' width='100%' />
      <Wrapepr>
        <StepWrapper>
          <Number>2</Number>
          <SubTitle>
            출입국기록출력 여부 <Strong>'Y'</Strong> 선택
          </SubTitle>
        </StepWrapper>
        <StepWrapper>
          <Number>3</Number>
          <div>
            <SubTitle>
              주민등록번호 뒷자리 <Strong>'미표시'</Strong> 선택
            </SubTitle>
            <SubTitle>
              발급용도 <Strong>'금융 · 병원 제출'</Strong> 선택
            </SubTitle>
          </div>
        </StepWrapper>
        <StepWrapper>
          <Number></Number>
          <SubTitle>
            그 외는 <Strong>'N'</Strong> 선택
          </SubTitle>
        </StepWrapper>
      </Wrapepr>
    </div>
  );
};
export default ExplainDetail;

const Wrapepr = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--KTP-Grayscale-Gray_12, #f4f4f4);
  margin-top: 14px;
`;

const StepWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const Number = styled.div`
  width: 17px;
  height: 17px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: -0.2px;
  background-color: #111;
  text-align: center;
  border-radius: 50%;
`;

const TitleWrapper = styled.div`
  display: flex;
  gap: 6px;
`;

const SubTitle = styled.p`
  color: #333;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Text = styled.p<{ $isRed?: boolean }>`
  color: ${({ $isRed }) => ($isRed ? '#ED0828' : '#333')};
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const Strong = styled.strong`
  font-weight: 700;
`;

const Small = styled.small`
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.24px;
`;

const ExampleWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const ExampleText = styled.p`
  border-radius: 3px;
  background: var(--KTP-Grayscale-Gray_10, #ddd);
  width: 54px;
  padding: 4px;
  color: #111;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.24px;
  text-align: center;
`;

const SecondImg = styled.img`
  margin-top: 42px;
`;
